const actions = {
  addOrdinarySearchData: ({commit}) => {
    commit('addOrdinarySearchData')
  },
  isShow: ({commit}) => {
    commit('isShow')
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js